var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 639,
    height: 662,
    viewBox: "0 0 639 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 627,
    height: 648.345,
    rx: 26.6809,
    fill: "#FFFDFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 122.396,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 133.068,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 145.074,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 157.081,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 157.081,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 202.438,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 213.111,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 225.117,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 237.124,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 237.124,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 282.481,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 293.153,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 305.16,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 317.166,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 317.166,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 362.523,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 373.196,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 385.202,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 397.209,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 397.209,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 442.566,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 453.239,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 465.245,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 477.251,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 477.251,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.189,
    y: 522.608,
    width: 228.121,
    height: 53.3617,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 533.281,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 545.287,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.533,
    y: 557.293,
    width: 101.387,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.922,
    y: 557.293,
    width: 58.6979,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.6895,
    y: 85.0426,
    width: 228.121,
    height: 146.745,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 138.404,
    width: 122.732,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 150.411,
    width: 132.07,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 165.085,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 173.09,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 181.094,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 102.385,
    width: 26.6809,
    height: 26.6809,
    rx: 2.66809,
    fill: "#D6E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 110.461C107.424 109.81 106.975 109.308 106.388 108.956C105.801 108.593 105.118 108.412 104.339 108.412C103.56 108.412 102.856 108.593 102.226 108.956C101.607 109.308 101.116 109.821 100.753 110.493C100.401 111.155 100.225 111.923 100.225 112.798C100.225 113.673 100.401 114.442 100.753 115.104C101.116 115.765 101.607 116.277 102.226 116.64C102.856 116.993 103.56 117.169 104.339 117.169C105.428 117.169 106.324 116.843 107.029 116.192C107.733 115.541 108.144 114.661 108.261 113.551H103.811V112.366H109.814V113.487C109.729 114.404 109.441 115.248 108.95 116.016C108.459 116.774 107.813 117.377 107.013 117.825C106.212 118.263 105.321 118.481 104.339 118.481C103.304 118.481 102.359 118.241 101.506 117.761C100.652 117.27 99.9742 116.592 99.4726 115.728C98.9817 114.863 98.7362 113.887 98.7362 112.798C98.7362 111.71 98.9817 110.733 99.4726 109.869C99.9742 108.994 100.652 108.316 101.506 107.836C102.359 107.345 103.304 107.099 104.339 107.099C105.524 107.099 106.57 107.393 107.477 107.98C108.395 108.567 109.062 109.394 109.478 110.461H107.733ZM115.349 107.227C116.566 107.227 117.617 107.457 118.503 107.916C119.399 108.364 120.082 109.01 120.552 109.853C121.032 110.696 121.272 111.688 121.272 112.83C121.272 113.972 121.032 114.965 120.552 115.808C120.082 116.64 119.399 117.281 118.503 117.729C117.617 118.166 116.566 118.385 115.349 118.385H111.875V107.227H115.349ZM115.349 117.185C116.79 117.185 117.889 116.806 118.647 116.048C119.404 115.28 119.783 114.207 119.783 112.83C119.783 111.443 119.399 110.36 118.631 109.581C117.873 108.801 116.779 108.412 115.349 108.412H113.332V117.185H115.349ZM130.788 110.493C130.788 111.422 130.468 112.195 129.828 112.814C129.198 113.423 128.232 113.727 126.93 113.727H124.785V118.385H123.328V107.227H126.93C128.19 107.227 129.145 107.531 129.796 108.14C130.458 108.748 130.788 109.533 130.788 110.493ZM126.93 112.526C127.741 112.526 128.339 112.35 128.723 111.998C129.108 111.646 129.3 111.144 129.3 110.493C129.3 109.116 128.51 108.428 126.93 108.428H124.785V112.526H126.93ZM138.609 118.385L135.952 113.823H134.191V118.385H132.734V107.227H136.336C137.179 107.227 137.889 107.371 138.465 107.66C139.052 107.948 139.489 108.337 139.778 108.828C140.066 109.319 140.21 109.879 140.21 110.509C140.21 111.277 139.986 111.955 139.537 112.542C139.1 113.129 138.438 113.519 137.552 113.711L140.354 118.385H138.609ZM134.191 112.654H136.336C137.126 112.654 137.718 112.462 138.113 112.078C138.508 111.683 138.705 111.16 138.705 110.509C138.705 109.847 138.508 109.335 138.113 108.972C137.728 108.609 137.136 108.428 136.336 108.428H134.191V112.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.106,
    y: 193.1,
    width: 53.3617,
    height: 24.0128,
    rx: 2.66809,
    fill: "#9FB3D6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.6895,
    y: 274.477,
    width: 228.121,
    height: 146.745,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 327.838,
    width: 122.732,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 339.845,
    width: 132.07,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 354.519,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 362.523,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 370.528,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 291.819,
    width: 26.6809,
    height: 26.6809,
    rx: 2.66809,
    fill: "#D6E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.737 296.661V307.819H99.2805V296.661H100.737ZM106.893 307.931C106.156 307.931 105.495 307.803 104.908 307.547C104.331 307.28 103.878 306.917 103.547 306.458C103.216 305.989 103.045 305.45 103.035 304.842H104.588C104.641 305.364 104.854 305.807 105.228 306.17C105.612 306.522 106.167 306.698 106.893 306.698C107.587 306.698 108.131 306.528 108.526 306.186C108.931 305.834 109.134 305.386 109.134 304.842C109.134 304.415 109.017 304.068 108.782 303.801C108.547 303.534 108.254 303.331 107.901 303.193C107.549 303.054 107.074 302.904 106.477 302.744C105.74 302.552 105.148 302.36 104.7 302.168C104.262 301.976 103.883 301.677 103.563 301.272C103.254 300.855 103.099 300.3 103.099 299.607C103.099 298.998 103.254 298.459 103.563 297.99C103.873 297.52 104.305 297.157 104.86 296.901C105.425 296.645 106.071 296.517 106.797 296.517C107.843 296.517 108.696 296.779 109.358 297.301C110.03 297.824 110.409 298.518 110.495 299.383H108.894C108.841 298.956 108.616 298.582 108.222 298.262C107.827 297.931 107.304 297.766 106.653 297.766C106.044 297.766 105.548 297.926 105.164 298.246C104.78 298.555 104.588 298.993 104.588 299.559C104.588 299.964 104.7 300.295 104.924 300.551C105.159 300.807 105.441 301.005 105.772 301.144C106.114 301.272 106.589 301.421 107.197 301.592C107.933 301.795 108.526 301.997 108.974 302.2C109.422 302.392 109.806 302.696 110.127 303.113C110.447 303.518 110.607 304.073 110.607 304.777C110.607 305.322 110.463 305.834 110.175 306.314C109.886 306.795 109.46 307.184 108.894 307.483C108.328 307.782 107.661 307.931 106.893 307.931ZM117.944 307.931C116.909 307.931 115.964 307.691 115.111 307.211C114.257 306.72 113.579 306.042 113.077 305.178C112.587 304.303 112.341 303.321 112.341 302.232C112.341 301.144 112.587 300.167 113.077 299.303C113.579 298.427 114.257 297.75 115.111 297.269C115.964 296.779 116.909 296.533 117.944 296.533C118.99 296.533 119.94 296.779 120.794 297.269C121.647 297.75 122.32 298.422 122.811 299.287C123.302 300.151 123.547 301.133 123.547 302.232C123.547 303.331 123.302 304.313 122.811 305.178C122.32 306.042 121.647 306.72 120.794 307.211C119.94 307.691 118.99 307.931 117.944 307.931ZM117.944 306.666C118.723 306.666 119.422 306.485 120.041 306.122C120.671 305.759 121.162 305.242 121.514 304.569C121.877 303.897 122.058 303.118 122.058 302.232C122.058 301.336 121.877 300.557 121.514 299.895C121.162 299.223 120.676 298.705 120.057 298.342C119.438 297.979 118.734 297.798 117.944 297.798C117.154 297.798 116.45 297.979 115.831 298.342C115.212 298.705 114.721 299.223 114.358 299.895C114.006 300.557 113.83 301.336 113.83 302.232C113.83 303.118 114.006 303.897 114.358 304.569C114.721 305.242 115.212 305.759 115.831 306.122C116.461 306.485 117.165 306.666 117.944 306.666ZM125.189 306.65C126.544 305.562 127.606 304.671 128.375 303.977C129.143 303.273 129.789 302.542 130.312 301.784C130.845 301.015 131.112 300.263 131.112 299.527C131.112 298.833 130.941 298.289 130.6 297.894C130.269 297.488 129.73 297.285 128.983 297.285C128.257 297.285 127.691 297.515 127.286 297.974C126.891 298.422 126.678 299.025 126.646 299.783H125.237C125.28 298.588 125.642 297.664 126.325 297.013C127.008 296.362 127.889 296.037 128.967 296.037C130.066 296.037 130.936 296.341 131.576 296.949C132.227 297.558 132.553 298.395 132.553 299.463C132.553 300.348 132.286 301.213 131.752 302.056C131.229 302.888 130.632 303.625 129.959 304.265C129.287 304.895 128.428 305.631 127.382 306.474H132.889V307.691H125.189V306.65ZM141.832 297.382L137.381 307.819H135.908L140.423 297.526H134.244V296.277H141.832V297.382ZM143.582 301.912C143.582 300.076 143.88 298.646 144.478 297.622C145.076 296.586 146.122 296.069 147.616 296.069C149.099 296.069 150.14 296.586 150.737 297.622C151.335 298.646 151.634 300.076 151.634 301.912C151.634 303.78 151.335 305.231 150.737 306.266C150.14 307.301 149.099 307.819 147.616 307.819C146.122 307.819 145.076 307.301 144.478 306.266C143.88 305.231 143.582 303.78 143.582 301.912ZM150.193 301.912C150.193 300.983 150.129 300.199 150.001 299.559C149.884 298.908 149.633 298.385 149.249 297.99C148.875 297.595 148.331 297.398 147.616 297.398C146.89 297.398 146.335 297.595 145.951 297.99C145.577 298.385 145.327 298.908 145.198 299.559C145.081 300.199 145.022 300.983 145.022 301.912C145.022 302.872 145.081 303.678 145.198 304.329C145.327 304.98 145.577 305.503 145.951 305.898C146.335 306.293 146.89 306.49 147.616 306.49C148.331 306.49 148.875 306.293 149.249 305.898C149.633 305.503 149.884 304.98 150.001 304.329C150.129 303.678 150.193 302.872 150.193 301.912ZM153.769 301.912C153.769 300.076 154.068 298.646 154.665 297.622C155.263 296.586 156.309 296.069 157.803 296.069C159.286 296.069 160.327 296.586 160.925 297.622C161.522 298.646 161.821 300.076 161.821 301.912C161.821 303.78 161.522 305.231 160.925 306.266C160.327 307.301 159.286 307.819 157.803 307.819C156.309 307.819 155.263 307.301 154.665 306.266C154.068 305.231 153.769 303.78 153.769 301.912ZM160.38 301.912C160.38 300.983 160.316 300.199 160.188 299.559C160.071 298.908 159.82 298.385 159.436 297.99C159.062 297.595 158.518 297.398 157.803 297.398C157.077 297.398 156.522 297.595 156.138 297.99C155.764 298.385 155.514 298.908 155.386 299.559C155.268 300.199 155.209 300.983 155.209 301.912C155.209 302.872 155.268 303.678 155.386 304.329C155.514 304.98 155.764 305.503 156.138 305.898C156.522 306.293 157.077 306.49 157.803 306.49C158.518 306.49 159.062 306.293 159.436 305.898C159.82 305.503 160.071 304.98 160.188 304.329C160.316 303.678 160.38 302.872 160.38 301.912ZM163.572 297.574V296.245H166.581V307.819H165.108V297.574H163.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.106,
    y: 382.534,
    width: 53.3617,
    height: 24.0128,
    rx: 2.66809,
    fill: "#9FB3D6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ddd_1671_6028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.6895,
    y: 463.911,
    width: 228.121,
    height: 146.745,
    rx: 13.3404,
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 517.272,
    width: 122.732,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 529.279,
    width: 132.07,
    height: 9.3383,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 543.953,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 551.957,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 559.962,
    width: 193.436,
    height: 5.33617,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0332,
    y: 481.253,
    width: 26.6809,
    height: 26.6809,
    rx: 2.66809,
    fill: "#D6E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.818 497.365C102.082 497.365 101.42 497.237 100.833 496.981C100.257 496.714 99.8035 496.351 99.4726 495.892C99.1418 495.423 98.971 494.884 98.9603 494.275H100.513C100.567 494.798 100.78 495.241 101.154 495.604C101.538 495.956 102.093 496.132 102.818 496.132C103.512 496.132 104.056 495.962 104.451 495.62C104.857 495.268 105.06 494.82 105.06 494.275C105.06 493.849 104.942 493.502 104.707 493.235C104.473 492.968 104.179 492.765 103.827 492.627C103.475 492.488 103 492.338 102.402 492.178C101.666 491.986 101.073 491.794 100.625 491.602C100.188 491.41 99.8088 491.111 99.4886 490.706C99.1791 490.289 99.0244 489.734 99.0244 489.041C99.0244 488.432 99.1791 487.893 99.4886 487.424C99.7981 486.954 100.23 486.591 100.785 486.335C101.351 486.079 101.997 485.951 102.722 485.951C103.768 485.951 104.622 486.213 105.284 486.735C105.956 487.258 106.335 487.952 106.42 488.817H104.819C104.766 488.39 104.542 488.016 104.147 487.696C103.752 487.365 103.229 487.2 102.578 487.2C101.97 487.2 101.474 487.36 101.089 487.68C100.705 487.989 100.513 488.427 100.513 488.993C100.513 489.398 100.625 489.729 100.849 489.985C101.084 490.241 101.367 490.439 101.698 490.578C102.039 490.706 102.514 490.855 103.123 491.026C103.859 491.229 104.451 491.431 104.899 491.634C105.348 491.826 105.732 492.13 106.052 492.547C106.372 492.952 106.532 493.507 106.532 494.211C106.532 494.756 106.388 495.268 106.1 495.748C105.812 496.229 105.385 496.618 104.819 496.917C104.254 497.216 103.587 497.365 102.818 497.365ZM113.87 497.365C112.834 497.365 111.89 497.125 111.036 496.645C110.182 496.154 109.505 495.476 109.003 494.612C108.512 493.737 108.267 492.755 108.267 491.666C108.267 490.578 108.512 489.601 109.003 488.737C109.505 487.861 110.182 487.184 111.036 486.703C111.89 486.213 112.834 485.967 113.87 485.967C114.916 485.967 115.865 486.213 116.719 486.703C117.573 487.184 118.245 487.856 118.736 488.721C119.227 489.585 119.473 490.567 119.473 491.666C119.473 492.765 119.227 493.747 118.736 494.612C118.245 495.476 117.573 496.154 116.719 496.645C115.865 497.125 114.916 497.365 113.87 497.365ZM113.87 496.1C114.649 496.1 115.348 495.919 115.967 495.556C116.596 495.193 117.087 494.676 117.44 494.003C117.802 493.331 117.984 492.552 117.984 491.666C117.984 490.77 117.802 489.991 117.44 489.329C117.087 488.656 116.602 488.139 115.983 487.776C115.364 487.413 114.659 487.232 113.87 487.232C113.08 487.232 112.376 487.413 111.757 487.776C111.138 488.139 110.647 488.656 110.284 489.329C109.932 489.991 109.755 490.77 109.755 491.666C109.755 492.552 109.932 493.331 110.284 494.003C110.647 494.676 111.138 495.193 111.757 495.556C112.386 495.919 113.091 496.1 113.87 496.1ZM126.093 491.682L129.519 497.253H127.87L125.197 492.899L122.651 497.253H121.034L124.444 491.682L121.018 486.095H122.651L125.341 490.465L127.902 486.095H129.535L126.093 491.682ZM137.468 486.095V497.253H136.011V486.095H137.468ZM146.953 486.095V487.28H143.911V497.253H142.455V487.28H139.397V486.095H146.953ZM157.334 489.329C157.024 488.678 156.576 488.176 155.989 487.824C155.402 487.461 154.719 487.28 153.94 487.28C153.161 487.28 152.456 487.461 151.827 487.824C151.208 488.176 150.717 488.688 150.354 489.361C150.002 490.023 149.826 490.791 149.826 491.666C149.826 492.541 150.002 493.31 150.354 493.971C150.717 494.633 151.208 495.145 151.827 495.508C152.456 495.86 153.161 496.036 153.94 496.036C155.028 496.036 155.925 495.711 156.629 495.06C157.334 494.409 157.744 493.528 157.862 492.418H153.412V491.234H159.415V492.354C159.329 493.272 159.041 494.115 158.55 494.884C158.059 495.642 157.414 496.245 156.613 496.693C155.813 497.13 154.922 497.349 153.94 497.349C152.905 497.349 151.96 497.109 151.106 496.629C150.252 496.138 149.575 495.46 149.073 494.596C148.582 493.731 148.337 492.755 148.337 491.666C148.337 490.578 148.582 489.601 149.073 488.737C149.575 487.861 150.252 487.184 151.106 486.703C151.96 486.213 152.905 485.967 153.94 485.967C155.124 485.967 156.17 486.261 157.077 486.848C157.995 487.434 158.662 488.262 159.079 489.329H157.334ZM160.931 491.666C160.931 490.578 161.177 489.601 161.668 488.737C162.159 487.861 162.826 487.178 163.669 486.687C164.523 486.197 165.467 485.951 166.502 485.951C167.719 485.951 168.781 486.245 169.688 486.832C170.595 487.418 171.257 488.251 171.673 489.329H169.928C169.619 488.656 169.17 488.139 168.583 487.776C168.007 487.413 167.313 487.232 166.502 487.232C165.723 487.232 165.024 487.413 164.405 487.776C163.786 488.139 163.301 488.656 162.948 489.329C162.596 489.991 162.42 490.77 162.42 491.666C162.42 492.552 162.596 493.331 162.948 494.003C163.301 494.665 163.786 495.177 164.405 495.54C165.024 495.903 165.723 496.084 166.502 496.084C167.313 496.084 168.007 495.908 168.583 495.556C169.17 495.193 169.619 494.676 169.928 494.003H171.673C171.257 495.071 170.595 495.898 169.688 496.485C168.781 497.061 167.719 497.349 166.502 497.349C165.467 497.349 164.523 497.109 163.669 496.629C162.826 496.138 162.159 495.46 161.668 494.596C161.177 493.731 160.931 492.755 160.931 491.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.106,
    y: 571.968,
    width: 53.3617,
    height: 24.0128,
    rx: 2.66809,
    fill: "#9FB3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1145 41.4056V42.8864H52.0512V47.5889H56.9739V49.0697H52.0512V55.353H50.2303V41.4056H58.1145ZM62.1347 46.1681C62.4549 45.5411 62.9085 45.0542 63.4955 44.7074C64.0958 44.3605 64.8228 44.1871 65.6766 44.1871V46.0681H65.1964C63.1553 46.0681 62.1347 47.1753 62.1347 49.3899V55.353H60.3138V44.3872H62.1347V46.1681ZM67.0983 49.8301C67.0983 48.7095 67.3251 47.729 67.7787 46.8885C68.2322 46.0347 68.8526 45.3744 69.6397 44.9075C70.4401 44.4406 71.3272 44.2071 72.3011 44.2071C73.2616 44.2071 74.0954 44.4139 74.8024 44.8274C75.5094 45.241 76.0364 45.7613 76.3832 46.3883V44.3872H78.2242V55.353H76.3832V53.3119C76.0231 53.9523 75.4828 54.4859 74.7624 54.9128C74.0553 55.3263 73.2282 55.5331 72.2811 55.5331C71.3072 55.5331 70.4267 55.293 69.6397 54.8127C68.8526 54.3325 68.2322 53.6588 67.7787 52.7917C67.3251 51.9245 67.0983 50.9373 67.0983 49.8301ZM76.3832 49.8501C76.3832 49.023 76.2165 48.3026 75.883 47.689C75.5495 47.0753 75.0959 46.6084 74.5223 46.2882C73.962 45.9547 73.3416 45.7879 72.6613 45.7879C71.9809 45.7879 71.3606 45.948 70.8003 46.2682C70.24 46.5884 69.7931 47.0553 69.4596 47.6689C69.1261 48.2826 68.9593 49.003 68.9593 49.8301C68.9593 50.6705 69.1261 51.4043 69.4596 52.0313C69.7931 52.6449 70.24 53.1185 70.8003 53.452C71.3606 53.7722 71.9809 53.9323 72.6613 53.9323C73.3416 53.9323 73.962 53.7722 74.5223 53.452C75.0959 53.1185 75.5495 52.6449 75.883 52.0313C76.2165 51.4043 76.3832 50.6772 76.3832 49.8501ZM94.4885 44.1871C95.3423 44.1871 96.1027 44.3672 96.7697 44.7274C97.4367 45.0742 97.9637 45.6012 98.3505 46.3082C98.7374 47.0153 98.9309 47.8757 98.9309 48.8896V55.353H97.1299V49.1497C97.1299 48.0558 96.8564 47.222 96.3095 46.6484C95.7758 46.0614 95.0488 45.7679 94.1283 45.7679C93.1811 45.7679 92.4274 46.0748 91.8671 46.6884C91.3068 47.2887 91.0267 48.1625 91.0267 49.3098V55.353H89.2257V49.1497C89.2257 48.0558 88.9522 47.222 88.4053 46.6484C87.8716 46.0614 87.1446 45.7679 86.2241 45.7679C85.2769 45.7679 84.5232 46.0748 83.9629 46.6884C83.4026 47.2887 83.1225 48.1625 83.1225 49.3098V55.353H81.3015V44.3872H83.1225V45.968C83.4826 45.3944 83.9629 44.9542 84.5632 44.6473C85.1769 44.3405 85.8506 44.1871 86.5843 44.1871C87.5048 44.1871 88.3185 44.3939 89.0256 44.8074C89.7326 45.221 90.2596 45.828 90.6064 46.6284C90.9133 45.8546 91.4202 45.2543 92.1272 44.8274C92.8343 44.4005 93.6214 44.1871 94.4885 44.1871ZM111.923 49.4499C111.923 49.7967 111.903 50.1636 111.863 50.5505H103.099C103.165 51.631 103.532 52.4782 104.199 53.0918C104.879 53.6921 105.7 53.9923 106.66 53.9923C107.448 53.9923 108.101 53.8122 108.621 53.452C109.155 53.0785 109.529 52.5849 109.742 51.9712H111.703C111.41 53.0251 110.823 53.8856 109.942 54.5526C109.062 55.2063 107.968 55.5331 106.66 55.5331C105.62 55.5331 104.686 55.2997 103.859 54.8328C103.045 54.3658 102.405 53.7055 101.938 52.8517C101.471 51.9846 101.238 50.984 101.238 49.8501C101.238 48.7162 101.464 47.7223 101.918 46.8685C102.371 46.0147 103.005 45.361 103.819 44.9075C104.646 44.4406 105.593 44.2071 106.66 44.2071C107.701 44.2071 108.621 44.4339 109.422 44.8875C110.222 45.341 110.836 45.968 111.263 46.7685C111.703 47.5555 111.923 48.4494 111.923 49.4499ZM110.042 49.0697C110.042 48.376 109.889 47.7823 109.582 47.2887C109.275 46.7818 108.855 46.4016 108.321 46.1481C107.801 45.8813 107.221 45.7479 106.58 45.7479C105.66 45.7479 104.873 46.0414 104.219 46.6284C103.579 47.2154 103.212 48.0291 103.119 49.0697H110.042ZM128.935 44.3872L125.513 55.353H123.632L120.99 46.6484L118.349 55.353H116.468L113.026 44.3872H114.887L117.408 53.5921L120.13 44.3872H121.991L124.652 53.6121L127.134 44.3872H128.935ZM135.524 55.5331C134.497 55.5331 133.563 55.2997 132.723 54.8328C131.896 54.3658 131.242 53.7055 130.762 52.8517C130.295 51.9846 130.061 50.984 130.061 49.8501C130.061 48.7295 130.302 47.7423 130.782 46.8885C131.275 46.0214 131.942 45.361 132.783 44.9075C133.623 44.4406 134.564 44.2071 135.604 44.2071C136.645 44.2071 137.585 44.4406 138.426 44.9075C139.266 45.361 139.927 46.0147 140.407 46.8685C140.901 47.7223 141.147 48.7162 141.147 49.8501C141.147 50.984 140.894 51.9846 140.387 52.8517C139.893 53.7055 139.22 54.3658 138.366 54.8328C137.512 55.2997 136.565 55.5331 135.524 55.5331ZM135.524 53.9323C136.178 53.9323 136.792 53.7789 137.365 53.472C137.939 53.1652 138.399 52.705 138.746 52.0913C139.106 51.4776 139.286 50.7306 139.286 49.8501C139.286 48.9696 139.113 48.2226 138.766 47.6089C138.419 46.9952 137.966 46.5417 137.405 46.2482C136.845 45.9414 136.238 45.7879 135.584 45.7879C134.917 45.7879 134.304 45.9414 133.743 46.2482C133.196 46.5417 132.756 46.9952 132.423 47.6089C132.089 48.2226 131.922 48.9696 131.922 49.8501C131.922 50.7439 132.083 51.4976 132.403 52.1113C132.736 52.725 133.176 53.1852 133.723 53.492C134.27 53.7855 134.871 53.9323 135.524 53.9323ZM145.363 46.1681C145.683 45.5411 146.136 45.0542 146.723 44.7074C147.324 44.3605 148.051 44.1871 148.904 44.1871V46.0681H148.424C146.383 46.0681 145.363 47.1753 145.363 49.3899V55.353H143.542V44.3872H145.363V46.1681ZM157.13 55.353L152.827 50.5105V55.353H151.007V40.5452H152.827V49.2498L157.05 44.3872H159.591L154.428 49.8501L159.611 55.353H157.13ZM165.187 55.5331C164.347 55.5331 163.593 55.393 162.926 55.1129C162.259 54.8194 161.732 54.4192 161.345 53.9123C160.958 53.392 160.745 52.7983 160.705 52.1313H162.586C162.639 52.6783 162.892 53.1252 163.346 53.472C163.813 53.8189 164.42 53.9923 165.167 53.9923C165.861 53.9923 166.408 53.8389 166.808 53.5321C167.208 53.2252 167.408 52.8384 167.408 52.3714C167.408 51.8912 167.195 51.5377 166.768 51.3109C166.341 51.0707 165.681 50.8373 164.787 50.6105C163.973 50.3971 163.306 50.1836 162.786 49.9702C162.279 49.7434 161.839 49.4165 161.465 48.9896C161.105 48.5494 160.925 47.9758 160.925 47.2687C160.925 46.7084 161.092 46.1948 161.425 45.7279C161.759 45.261 162.232 44.8941 162.846 44.6273C163.459 44.3472 164.16 44.2071 164.947 44.2071C166.161 44.2071 167.141 44.5139 167.888 45.1276C168.636 45.7412 169.036 46.5817 169.089 47.6489H167.268C167.228 47.0753 166.995 46.615 166.568 46.2682C166.154 45.9213 165.594 45.7479 164.887 45.7479C164.233 45.7479 163.713 45.888 163.326 46.1681C162.939 46.4483 162.746 46.8152 162.746 47.2687C162.746 47.6289 162.859 47.9291 163.086 48.1692C163.326 48.396 163.62 48.5828 163.966 48.7295C164.327 48.8629 164.82 49.0163 165.447 49.1897C166.234 49.4032 166.875 49.6166 167.368 49.8301C167.862 50.0302 168.282 50.337 168.629 50.7506C168.989 51.1641 169.176 51.7044 169.189 52.3714C169.189 52.9718 169.022 53.512 168.689 53.9923C168.355 54.4726 167.882 54.8528 167.268 55.1329C166.668 55.3997 165.974 55.5331 165.187 55.5331Z",
    fill: "#373131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05 48.3693C363.05 47.0086 363.357 45.7879 363.97 44.7074C364.584 43.6135 365.418 42.7597 366.472 42.146C367.539 41.5323 368.72 41.2255 370.014 41.2255C371.534 41.2255 372.862 41.5924 373.996 42.3261C375.13 43.0598 375.957 44.1004 376.477 45.4478H374.296C373.909 44.6073 373.349 43.9603 372.615 43.5067C371.895 43.0532 371.027 42.8264 370.014 42.8264C369.04 42.8264 368.166 43.0532 367.392 43.5067C366.618 43.9603 366.011 44.6073 365.571 45.4478C365.131 46.2749 364.911 47.2487 364.911 48.3693C364.911 49.4766 365.131 50.4504 365.571 51.2909C366.011 52.118 366.618 52.7583 367.392 53.2119C368.166 53.6655 369.04 53.8923 370.014 53.8923C371.027 53.8923 371.895 53.6721 372.615 53.2319C373.349 52.7783 373.909 52.1313 374.296 51.2909H376.477C375.957 52.6249 375.13 53.6588 373.996 54.3925C372.862 55.1129 371.534 55.4731 370.014 55.4731C368.72 55.4731 367.539 55.1729 366.472 54.5726C365.418 53.959 364.584 53.1118 363.97 52.0313C363.357 50.9507 363.05 49.73 363.05 48.3693ZM383.97 55.5331C382.943 55.5331 382.009 55.2997 381.169 54.8328C380.342 54.3658 379.688 53.7055 379.208 52.8517C378.741 51.9846 378.507 50.984 378.507 49.8501C378.507 48.7295 378.747 47.7423 379.228 46.8885C379.721 46.0214 380.388 45.361 381.229 44.9075C382.069 44.4406 383.01 44.2071 384.05 44.2071C385.091 44.2071 386.031 44.4406 386.872 44.9075C387.712 45.361 388.373 46.0147 388.853 46.8685C389.346 47.7223 389.593 48.7162 389.593 49.8501C389.593 50.984 389.34 51.9846 388.833 52.8517C388.339 53.7055 387.666 54.3658 386.812 54.8328C385.958 55.2997 385.011 55.5331 383.97 55.5331ZM383.97 53.9323C384.624 53.9323 385.238 53.7789 385.811 53.472C386.385 53.1652 386.845 52.705 387.192 52.0913C387.552 51.4776 387.732 50.7306 387.732 49.8501C387.732 48.9696 387.559 48.2226 387.212 47.6089C386.865 46.9952 386.412 46.5417 385.851 46.2482C385.291 45.9414 384.684 45.7879 384.03 45.7879C383.363 45.7879 382.75 45.9414 382.189 46.2482C381.642 46.5417 381.202 46.9952 380.869 47.6089C380.535 48.2226 380.368 48.9696 380.368 49.8501C380.368 50.7439 380.528 51.4976 380.849 52.1113C381.182 52.725 381.622 53.1852 382.169 53.492C382.716 53.7855 383.317 53.9323 383.97 53.9323ZM397.33 44.1871C398.664 44.1871 399.745 44.594 400.572 45.4077C401.399 46.2082 401.813 47.3688 401.813 48.8896V55.353H400.012V49.1497C400.012 48.0558 399.738 47.222 399.191 46.6484C398.644 46.0614 397.897 45.7679 396.95 45.7679C395.99 45.7679 395.223 46.0681 394.649 46.6684C394.089 47.2687 393.808 48.1425 393.808 49.2898V55.353H391.987V44.3872H393.808V45.948C394.169 45.3877 394.656 44.9542 395.269 44.6473C395.896 44.3405 396.583 44.1871 397.33 44.1871ZM407.008 45.888V52.3514C407.008 52.885 407.122 53.2653 407.349 53.492C407.575 53.7055 407.969 53.8122 408.529 53.8122H409.87V55.353H408.229C407.215 55.353 406.455 55.1196 405.948 54.6527C405.441 54.1857 405.187 53.4187 405.187 52.3514V45.888H403.767V44.3872H405.187V41.6257H407.008V44.3872H409.87V45.888H407.008ZM413.897 46.1681C414.217 45.5411 414.671 45.0542 415.258 44.7074C415.858 44.3605 416.585 44.1871 417.439 44.1871V46.0681H416.959C414.918 46.0681 413.897 47.1753 413.897 49.3899V55.353H412.076V44.3872H413.897V46.1681ZM424.324 55.5331C423.297 55.5331 422.363 55.2997 421.522 54.8328C420.695 54.3658 420.041 53.7055 419.561 52.8517C419.094 51.9846 418.861 50.984 418.861 49.8501C418.861 48.7295 419.101 47.7423 419.581 46.8885C420.075 46.0214 420.742 45.361 421.582 44.9075C422.423 44.4406 423.363 44.2071 424.404 44.2071C425.444 44.2071 426.385 44.4406 427.225 44.9075C428.066 45.361 428.726 46.0147 429.206 46.8685C429.7 47.7223 429.947 48.7162 429.947 49.8501C429.947 50.984 429.693 51.9846 429.186 52.8517C428.693 53.7055 428.019 54.3658 427.165 54.8328C426.311 55.2997 425.364 55.5331 424.324 55.5331ZM424.324 53.9323C424.977 53.9323 425.591 53.7789 426.165 53.472C426.738 53.1652 427.199 52.705 427.545 52.0913C427.906 51.4776 428.086 50.7306 428.086 49.8501C428.086 48.9696 427.912 48.2226 427.565 47.6089C427.219 46.9952 426.765 46.5417 426.205 46.2482C425.644 45.9414 425.037 45.7879 424.384 45.7879C423.717 45.7879 423.103 45.9414 422.543 46.2482C421.996 46.5417 421.556 46.9952 421.222 47.6089C420.889 48.2226 420.722 48.9696 420.722 49.8501C420.722 50.7439 420.882 51.4976 421.202 52.1113C421.536 52.725 421.976 53.1852 422.523 53.492C423.07 53.7855 423.67 53.9323 424.324 53.9323ZM434.162 40.5452V55.353H432.341V40.5452H434.162ZM441.148 55.5331C440.307 55.5331 439.553 55.393 438.886 55.1129C438.219 54.8194 437.692 54.4192 437.305 53.9123C436.919 53.392 436.705 52.7983 436.665 52.1313H438.546C438.6 52.6783 438.853 53.1252 439.307 53.472C439.773 53.8189 440.38 53.9923 441.128 53.9923C441.821 53.9923 442.368 53.8389 442.768 53.5321C443.169 53.2252 443.369 52.8384 443.369 52.3714C443.369 51.8912 443.155 51.5377 442.728 51.3109C442.301 51.0707 441.641 50.8373 440.747 50.6105C439.934 50.3971 439.267 50.1836 438.746 49.9702C438.239 49.7434 437.799 49.4165 437.426 48.9896C437.065 48.5494 436.885 47.9758 436.885 47.2687C436.885 46.7084 437.052 46.1948 437.386 45.7279C437.719 45.261 438.193 44.8941 438.806 44.6273C439.42 44.3472 440.12 44.2071 440.907 44.2071C442.121 44.2071 443.102 44.5139 443.849 45.1276C444.596 45.7412 444.996 46.5817 445.05 47.6489H443.229C443.189 47.0753 442.955 46.615 442.528 46.2682C442.115 45.9213 441.554 45.7479 440.847 45.7479C440.194 45.7479 439.673 45.888 439.287 46.1681C438.9 46.4483 438.706 46.8152 438.706 47.2687C438.706 47.6289 438.82 47.9291 439.046 48.1692C439.287 48.396 439.58 48.5828 439.927 48.7295C440.287 48.8629 440.781 49.0163 441.408 49.1897C442.195 49.4032 442.835 49.6166 443.329 49.8301C443.822 50.0302 444.243 50.337 444.589 50.7506C444.95 51.1641 445.136 51.7044 445.15 52.3714C445.15 52.9718 444.983 53.512 444.649 53.9923C444.316 54.4726 443.842 54.8528 443.229 55.1329C442.628 55.3997 441.935 55.5331 441.148 55.5331Z",
    fill: "#373131"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.778,
    y: 42.889,
    width: 129.402,
    height: 8.00426,
    fill: "#D5E2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.796,
    y: 54.201,
    width: 85.5556,
    height: 3.66667,
    fill: "#D5E2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 42.889,
    width: 129.402,
    height: 8.00426,
    fill: "#D5E2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.018,
    y: 54.201,
    width: 85.5556,
    height: 3.66667,
    fill: "#D5E2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.252 159.749C273.252 161.714 274.845 163.306 276.81 163.306C278.774 163.306 280.367 161.714 280.367 159.749C280.367 157.784 278.774 156.192 276.81 156.192C274.845 156.192 273.252 157.784 273.252 159.749ZM276.81 160.416H362.188V159.082H276.81V160.416Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.049 157.506C272.81 159.031 273.041 161.271 274.566 162.51C276.091 163.749 278.332 163.517 279.571 161.992C280.809 160.467 280.578 158.227 279.053 156.988C277.528 155.749 275.288 155.981 274.049 157.506ZM276.389 160.267L361.768 229.637L362.609 228.602L277.23 159.231L276.389 160.267Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.496 345.141C274.211 346.971 276.274 347.875 278.104 347.16C279.934 346.445 280.838 344.382 280.123 342.552C279.408 340.722 277.345 339.818 275.515 340.533C273.685 341.248 272.781 343.311 273.496 345.141ZM277.052 344.468L362.431 311.117L361.946 309.874L276.567 343.225L277.052 344.468Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.056 156.654C273.347 157.622 272.746 159.793 273.714 161.502C274.682 163.212 276.853 163.813 278.563 162.844C280.272 161.876 280.873 159.705 279.905 157.996C278.937 156.286 276.766 155.685 275.056 156.654ZM276.229 160.078L361.608 310.825L362.769 310.167L277.39 159.42L276.229 160.078Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.688 342.14C272.746 343.864 273.379 346.025 275.103 346.968C276.826 347.911 278.988 347.277 279.931 345.554C280.873 343.83 280.24 341.668 278.516 340.725C276.793 339.783 274.631 340.416 273.688 342.14ZM276.49 344.432L361.868 391.123L362.508 389.953L277.13 343.261L276.49 344.432Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.971 540.328C276.653 541.344 278.839 540.804 279.855 539.122C280.87 537.44 280.33 535.253 278.648 534.237C276.966 533.222 274.78 533.762 273.764 535.444C272.749 537.126 273.289 539.313 274.971 540.328ZM277.381 537.628L362.759 396.219L361.617 395.53L276.239 536.938L277.381 537.628Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.006 539.473C275.216 541.021 277.451 541.296 279 540.086C280.548 538.877 280.822 536.641 279.613 535.093C278.403 533.544 276.168 533.27 274.619 534.479C273.071 535.689 272.797 537.925 274.006 539.473ZM277.22 537.808L362.599 471.106L361.778 470.055L276.399 536.757L277.22 537.808Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.287 536.787C273.013 538.733 274.369 540.532 276.314 540.806C278.26 541.079 280.059 539.724 280.332 537.778C280.606 535.833 279.251 534.034 277.305 533.76C275.359 533.486 273.56 534.842 273.287 536.787ZM276.717 537.943L362.095 549.95L362.281 548.629L276.902 536.622L276.717 537.943Z",
    fill: "#A2BFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.822 340.896C273.192 341.994 272.761 344.205 273.859 345.834C274.957 347.464 277.168 347.895 278.797 346.797C280.427 345.699 280.858 343.489 279.76 341.859C278.662 340.23 276.451 339.799 274.822 340.896ZM276.256 344.219L361.635 470.953L362.742 470.208L277.363 343.474L276.256 344.219Z",
    fill: "#A2BFF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1671_6028",
    x: 0.366764,
    y: 0.493411,
    width: 638.266,
    height: 660.738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.25329
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.37994
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25329
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.12665
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81662
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_1671_6028",
    x: 348.849,
    y: 110.389,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_1671_6028",
    x: 348.849,
    y: 190.432,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddd_1671_6028",
    x: 348.849,
    y: 270.475,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddd_1671_6028",
    x: 348.849,
    y: 350.517,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddd_1671_6028",
    x: 348.849,
    y: 430.56,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddd_1671_6028",
    x: 348.849,
    y: 510.602,
    width: 254.802,
    height: 80.0425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ddd_1671_6028",
    x: 35.349,
    y: 73.0362,
    width: 254.802,
    height: 173.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ddd_1671_6028",
    x: 35.349,
    y: 262.47,
    width: 254.802,
    height: 173.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ddd_1671_6028",
    x: 35.349,
    y: 451.904,
    width: 254.802,
    height: 173.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6028",
    result: "effect2_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33404
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.67021
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6028",
    result: "effect3_dropShadow_1671_6028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6028",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFramework);
export default __webpack_public_path__ + "static/media/crossFramework.72fb0c9bb7a6860b6e733aa810df8832.svg";
export { ForwardRef as ReactComponent };